import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';
import { useEffect, useRef } from 'react';

const SlideBtnBlock = styled.button`
    width: 70px;
    height: 70px;
    &.slick-disabled {
    opacity: 0;
    width: 1px;
    height: 1px;
    }

     &.slick-arrow {
        position: absolute;
        top: ${props=>props.top};
        //width: 50px;
        //height: 50px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        //text-indent: -9999px;
        overflow: hidden;
        //border-radius: 10px;
        //-webkit-box-shadow: 0.9px 1.8px 12px 0 rgb(44 44 44 / 14%);
        //box-shadow: 0.9px 1.8px 12px 0 rgb(44 44 44 / 14%);
        //-webkit-transition: background 0.3s, opacity 0.3s;
        //-o-transition: background 0.3s, opacity 0.3s;
        //transition: background 0.3s, opacity 0.3s;
        z-index: 3;
    } 

    &.slick-next {
        right: -35px;
    }

    &.slick-prev {
        left: -35px;
    }


`;


const blurwidth = "40";
const activwidth = "34";
const blurrx = "20";
const activrx = "17";
const blurx = "0";
const activx = "3";

const SlideBtn = ( props) => {
    const { className, style, onClick, right, top } = props;
    const circle = useRef(null);
   
    const arrowID = Math.random();

    //console.log("className = " + className)
    //console.log("props = " + JSON.stringify(props))

    const onActive = () => window.TweenMax.to(circle.current, .5, {
        attr: { width: activwidth, rx: activrx, x:activx },
        transformOrigin: 'center',
        ease: window.Elastic.easeOut
      });
    
    const onBlur = () => window.TweenMax.to(circle.current, 1, {
        attr: { width: blurwidth, rx:  blurrx, x:blurx},
        ease: window.Elastic.easeOut
      });

    return (
        <SlideBtnBlock 
        onMouseDown={onActive}
        onTouchStart={onActive}
        onMouseLeave={onBlur}
        onMouseUp={onBlur}
        className={className? className:""}
        style={{ ...style}}
        onClick={onClick}
        top={top? top:'33%'}
      >
        <svg
          viewBox="0 0 70 70"
          preserveAspectRatio="none"
          width="100%" height="100%"
        >
        <defs>
            <filter id="bwse8byq7a" width="70" height="70" x="0" y="0" filterUnits="userSpaceOnUse">
                <feOffset dx=".877" dy="1.798"/>
                <feGaussianBlur result="blur" stdDeviation="5"/>
                <feFlood flood-color="#2c2c2c" flood-opacity=".239"/>
                <feComposite in2="blur" operator="in"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g filter="url(#bwse8byq7a)">
        <rect ref={circle}  width={blurwidth} height="40" fill="#fff" opacity="0.9" rx={blurrx} x={blurx} transform="translate(14.12 13.2)"/> 
        
        </g>
        {
            right?
            <path fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6px" d="M0 8l4-4-4-4" transform="translate(14.123 13.202) translate(18.499 16.5)"/>
            :
            <path fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6px" d="M4 8L0 4l4-4" transform="translate(14.123 13.202) translate(17.501 16.5)"/>
        }
        
    
        
          {/* <mask id={`${arrowID}`}>
            <rect fill="#fff" width="100%" height="100%"/>
            <path fill="#000" className="arrow" d="M48.5,61.5v-2.9h17.4l-8-8l2.1-2.1L71.5,60L60,71.5l-2.1-2.1l8-8H48.5z" />
          </mask>
          <path ref={circle} mask={`url(#${arrowID})`} d={blurShape} /> */}
        </svg>
        </SlideBtnBlock>
    )
};

export default SlideBtn;


